import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';

type ResultOptionProps = {
  description: string;
  callback: () => void;
};

export const ResultOption = ({ description, callback }: ResultOptionProps) => {
  return (
    <Button
      variant="text"
      className="hover:no-underline justify-start items-center gap-1"
      onClick={callback}
      data-testid={DataTestIdEnum.LOCATION_RESULT_OPTION}
    >
      <div className="min-w-5 max-w-5 min-h-5 max-h-5 flex justify-center self-center">
        <Icon icon={faLocationDot} className="text-gray-400 text-base self-center" />
      </div>
      <p className="text-gray-600 text-left font-medium leading-5 text-wrap">{description}</p>
    </Button>
  );
};
